import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navigation from "../components/Navigation";

const AddTransactionScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    symbol: location.state?.symbol || "",
    name: location.state?.name || "",
    type: location.state?.type || "buy",
    shares: "",
    price: "",
    date: new Date().toISOString().split("T")[0],
    fees: "",
    notes: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Adding transaction:", formData);
    alert("Transaction added successfully!");
    navigate("/transaction-history");
  };

  const calculateTotal = () => {
    const shares = parseFloat(formData.shares) || 0;
    const price = parseFloat(formData.price) || 0;
    const fees = parseFloat(formData.fees) || 0;
    return (shares * price + fees).toFixed(2);
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Add Transaction</h1>
        <p className="screen-subtitle">Record a buy or sell transaction</p>
      </div>

      <div className="form-container" style={{ maxWidth: "600px" }}>
        <form onSubmit={handleSubmit}>
          {/* Transaction Type */}
          <div className="form-group">
            <label className="form-label">Transaction Type</label>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() =>
                  setFormData((prev) => ({ ...prev, type: "buy" }))
                }
                className={`btn ${
                  formData.type === "buy" ? "" : "btn-outline"
                } btn-large`}
                style={{ flex: 1 }}
              >
                💰 Buy
              </button>
              <button
                type="button"
                onClick={() =>
                  setFormData((prev) => ({ ...prev, type: "sell" }))
                }
                className={`btn ${
                  formData.type === "sell" ? "btn-error" : "btn-outline"
                } btn-large`}
                style={{ flex: 1 }}
              >
                📉 Sell
              </button>
            </div>
          </div>

          {/* Symbol and Name */}
          <div className="grid-2">
            <div className="form-group">
              <label className="form-label">Symbol</label>
              <input
                type="text"
                name="symbol"
                value={formData.symbol}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g., AAPL"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Company Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="form-input"
                placeholder="e.g., Apple Inc."
                required
              />
            </div>
          </div>

          {/* Shares and Price */}
          <div className="grid-2">
            <div className="form-group">
              <label className="form-label">Number of Shares</label>
              <input
                type="number"
                name="shares"
                value={formData.shares}
                onChange={handleInputChange}
                className="form-input"
                placeholder="0.00"
                step="0.01"
                min="0"
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Price per Share</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleInputChange}
                className="form-input"
                placeholder="0.00"
                step="0.01"
                min="0"
                required
              />
            </div>
          </div>

          {/* Fees */}
          <div className="form-group">
            <label className="form-label">Fees & Commissions</label>
            <input
              type="number"
              name="fees"
              value={formData.fees}
              onChange={handleInputChange}
              className="form-input"
              placeholder="0.00"
              step="0.01"
              min="0"
            />
          </div>

          {/* Total Value Display */}
          <div className="card" style={{ marginBottom: "20px" }}>
            <div className="text-center">
              <div style={{ fontSize: "1.2rem", color: "#94A3B8" }}>
                Total {formData.type === "buy" ? "Cost" : "Proceeds"}
              </div>
              <div
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: "#E5E7EB",
                }}
              >
                ${calculateTotal()}
              </div>
            </div>
          </div>

          {/* Transaction Date */}
          <div className="form-group">
            <label className="form-label">Transaction Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              className="form-input"
              required
            />
          </div>

          {/* Notes */}
          <div className="form-group">
            <label className="form-label">Notes (Optional)</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Add any notes about this transaction..."
              rows="3"
              style={{ resize: "vertical" }}
            />
          </div>

          {/* Action Buttons */}
          <div className="grid-2" style={{ marginTop: "20px" }}>
            <button
              type="button"
              onClick={() => navigate("/invest")}
              className="btn btn-outline btn-large"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`btn btn-large ${
                formData.type === "sell" ? "btn-error" : ""
              }`}
            >
              {formData.type === "buy" ? "Buy" : "Sell"}{" "}
              {formData.symbol || "Stock"}
            </button>
          </div>
        </form>
      </div>

      <Navigation />
    </div>
  );
};

export default AddTransactionScreen;
